<template>
  <div>
    <ItemList
      :list-id="listId"
      :list-title="'Bids'"
      :group-by="'sold_status'"
    />
  </div>
</template>

<script>
import ItemList from '@/components/ItemList'

export default {
	name: 'BidsCard',
	components: {
		ItemList	
	},
	computed: {

		// this was formerly in mapState - can't use that due to Edge
		customer: function() {
			return this.$store.state.customer
		},

		// the list id for their Bids
		listId: function () {
			if (typeof (this.customer.bid_list_id) !== 'undefined') {
				return this.customer.bid_list_id
			}
		}
	}
}

</script>

<style scoped>

</style>
